export default "__VITE_ASSET__PC4oCMMA__"